import { hexToRGB } from '../../utils/colorConverter';
import { COLORS } from '../colors';
export const light = {
    background: {
        default: COLORS.WHITE[100],
        contrast: COLORS.WHITE[200],
        overlay: COLORS.WHITE[100],
        hover: hexToRGB(COLORS.PURPLE[900], 0.06),
        selected: hexToRGB(COLORS.PURPLE[900], 0.1),
        primary: COLORS.PRIMARY[100],
        critical: COLORS.PEACH[100],
        warning: COLORS.YELLOW[100],
        success: COLORS.TEAL[100],
    },
    border: {
        default: COLORS.WHITE[300],
        contrast: COLORS.WHITE[400],
        selected: COLORS.PURPLE[900],
        primary: COLORS.PRIMARY[200],
        critical: COLORS.PEACH[200],
        warning: COLORS.YELLOW[200],
        success: COLORS.TEAL[200],
    },
    content: {
        default: COLORS.PURPLE[900],
        contrast: COLORS.PURPLE[900],
        subdued: COLORS.PURPLE[100],
        disabled: COLORS.WHITE[700],
        placeholder: COLORS.WHITE[900],
        primary: COLORS.PRIMARY[600],
        critical: COLORS.PEACH[600],
        warning: COLORS.YELLOW[600],
        success: COLORS.TEAL[600],
        above: {
            primary: COLORS.WHITE[100],
            secondary: COLORS.PURPLE[900],
            text: COLORS.PURPLE[900],
            critical: COLORS.PEACH[600],
            contrast: COLORS.PURPLE[900],
        },
    },
    interactive: {
        primary: {
            default: COLORS.PURPLE[900],
            hover: COLORS.PURPLE[700],
            pressed: COLORS.PURPLE[600],
        },
        secondary: {
            default: hexToRGB(COLORS.PURPLE[900], 0.06),
            hover: hexToRGB(COLORS.PURPLE[900], 0.1),
            pressed: hexToRGB(COLORS.PURPLE[900], 0.12),
        },
        text: {
            default: hexToRGB(COLORS.PURPLE[900], 0),
            hover: hexToRGB(COLORS.PURPLE[900], 0.1),
            pressed: hexToRGB(COLORS.PURPLE[900], 0.12),
        },
        critical: {
            default: COLORS.PEACH[100],
            hover: COLORS.PEACH[200],
            pressed: COLORS.PEACH[300],
        },
        contrast: {
            default: hexToRGB(COLORS.WHITE[100], 1),
            hover: hexToRGB(COLORS.WHITE[100], 0.9),
            pressed: hexToRGB(COLORS.WHITE[100], 0.75),
        },
    },
    benefits: {
        mealVoucher: {
            content: {
                default: COLORS.PEACH[600],
                selected: COLORS.PEACH[700],
            },
            background: {
                default: COLORS.PEACH[100],
                selected: COLORS.PEACH[300],
            },
        },
        gift: {
            content: {
                default: COLORS.PINK[600],
                selected: COLORS.PINK[700],
            },
            background: {
                default: COLORS.PINK[100],
                selected: COLORS.PINK[300],
            },
        },
        mobility: {
            content: {
                default: COLORS.GREEN[600],
                selected: COLORS.GREEN[700],
            },
            background: {
                default: COLORS.GREEN[100],
                selected: COLORS.GREEN[300],
            },
        },
        wallet: {
            content: {
                default: COLORS.BLUE[600],
                selected: COLORS.BLUE[700],
            },
            background: {
                default: COLORS.BLUE[100],
                selected: COLORS.BLUE[300],
            },
        },
        cashback: {
            content: {
                default: COLORS.YELLOW[600],
                selected: COLORS.YELLOW[700],
            },
            background: {
                default: COLORS.YELLOW[100],
                selected: COLORS.YELLOW[300],
            },
        },
    },
    features: {
        pot: {
            content: {
                default: COLORS.BLUE[600],
                selected: COLORS.BLUE[700],
            },
            background: {
                default: COLORS.BLUE[100],
                selected: COLORS.BLUE[300],
            },
        },
        activity: {
            content: {
                default: COLORS.GREEN[600],
                selected: COLORS.GREEN[700],
            },
            background: {
                default: COLORS.GREEN[100],
                selected: COLORS.GREEN[300],
            },
        },
        pulse: {
            content: {
                default: COLORS.TEAL[600],
                selected: COLORS.TEAL[700],
            },
            background: {
                default: COLORS.TEAL[100],
                selected: COLORS.TEAL[300],
            },
        },
        article: {
            content: {
                default: COLORS.YELLOW[600],
                selected: COLORS.YELLOW[700],
            },
            background: {
                default: COLORS.YELLOW[100],
                selected: COLORS.YELLOW[300],
            },
        },
        praise: {
            content: {
                default: COLORS.PINK[600],
                selected: COLORS.PINK[700],
            },
            background: {
                default: COLORS.PINK[100],
                selected: COLORS.PINK[300],
            },
            birthday: {
                content: {
                    default: COLORS.PRIMARY[600],
                    selected: COLORS.PRIMARY[700],
                },
                background: {
                    default: COLORS.PRIMARY[100],
                    selected: COLORS.PRIMARY[300],
                },
            },
            celebration: {
                content: {
                    default: COLORS.PINK[600],
                    selected: COLORS.PINK[700],
                },
                background: {
                    default: COLORS.PINK[100],
                    selected: COLORS.PINK[300],
                },
            },
            congrats: {
                content: {
                    default: COLORS.GREEN[600],
                    selected: COLORS.GREEN[700],
                },
                background: {
                    default: COLORS.GREEN[100],
                    selected: COLORS.GREEN[300],
                },
            },
            egoBoost: {
                content: {
                    default: COLORS.BLUE[600],
                    selected: COLORS.BLUE[700],
                },
                background: {
                    default: COLORS.BLUE[100],
                    selected: COLORS.BLUE[300],
                },
            },
            onboarding: {
                content: {
                    default: COLORS.YELLOW[600],
                    selected: COLORS.YELLOW[700],
                },
                background: {
                    default: COLORS.YELLOW[100],
                    selected: COLORS.YELLOW[300],
                },
            },
            proCelebration: {
                content: {
                    default: COLORS.PEACH[600],
                    selected: COLORS.PEACH[700],
                },
                background: {
                    default: COLORS.PEACH[100],
                    selected: COLORS.PEACH[300],
                },
            },
            proAnniversary: {
                content: {
                    default: COLORS.PEACH[600],
                    selected: COLORS.PEACH[700],
                },
                background: {
                    default: COLORS.PEACH[100],
                    selected: COLORS.PEACH[300],
                },
            },
            thanks: {
                content: {
                    default: COLORS.PINK[600],
                    selected: COLORS.PINK[700],
                },
                background: {
                    default: COLORS.PINK[100],
                    selected: COLORS.PINK[300],
                },
            },
        },
    },
    cards: {
        black: {
            primary: '#111111',
            accent: '#272727',
        },
        grey: {
            primary: '#585858',
            accent: '#E5E5E5',
        },
        midnightBlue: {
            primary: '#00084B',
            accent: '#E5E8FF',
        },
        gold: {
            primary: '#C8BA95',
            accent: '#F3F0E7',
        },
        pink: {
            primary: '#EDC2BD',
            accent: '#F7E5E3',
        },
    },
};
